import { render, staticRenderFns } from "./DataForm.vue?vue&type=template&id=8c6283e4&scoped=true"
import script from "./DataForm.vue?vue&type=script&lang=js"
export * from "./DataForm.vue?vue&type=script&lang=js"
import style0 from "./DataForm.vue?vue&type=style&index=0&id=8c6283e4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c6283e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c6283e4')) {
      api.createRecord('8c6283e4', component.options)
    } else {
      api.reload('8c6283e4', component.options)
    }
    module.hot.accept("./DataForm.vue?vue&type=template&id=8c6283e4&scoped=true", function () {
      api.rerender('8c6283e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-setting/base-data/code-rule/components/DataForm.vue"
export default component.exports